/**
 * Before Interceptor.
 */

var _ = require('../util');

module.exports = {

    request: function (request) {

        if (_.isFunction(request.beforeSend)) {
            request.beforeSend.call(this, request);
        }

        return request;
    }

};



/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-resource/src/http/before.js
 ** module id = 62
 ** module chunks = 0
 **/